import { render, staticRenderFns } from "./FileExtensionOrFine.vue?vue&type=template&id=16e13944&scoped=true&"
import script from "./FileExtensionOrFine.vue?vue&type=script&lang=js&"
export * from "./FileExtensionOrFine.vue?vue&type=script&lang=js&"
import style0 from "./FileExtensionOrFine.vue?vue&type=style&index=0&id=16e13944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e13944",
  null
  
)

export default component.exports